import { WrappedResourceDetailPage } from './lib/ResourceDetail';
export * from './lib/components';
export default WrappedResourceDetailPage;
